<template>
    <div class="c-multi-search">
        
        <div class="c-multi-search__form">
            <div class="c-multi-search__search-types">
                <h3>Search all orders</h3>
                <select @change="searchTerm = ''; results = []; searching = false; date = null" v-model="searchType">
                    <option value="" disabled selected>I'd like to search by</option>
                    <option v-for="option in searchOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
                </select>
            </div>
            <div class="c-multi-search__input-container">
                <h3>{{ searchOptions.find(option => option.value === searchType)?.label }}</h3>
                <input v-if="searchType !== 'date'" :class="searchType" :disabled="!searchType || searchType === ''" type="text" v-model="searchTerm" placeholder="" >
                <VueDatePicker  
                    v-else 
                    v-model="date"
                    :range="true"
                    :format="'dd/MM/yyyy'"
                    :enable-time-picker="false"
                >
                </VueDatePicker>
            </div>

            <div class="c-multi-search__search-button" @click="searchOrders">Search</div>
        </div>

        <div v-if="searching" class="c-multi-search__results">

            <Loader v-if="loadingResults"/>

            <div v-else-if="error" class="c-multi-search__error">
                {{ error }}
            </div>

            <div class="c-multi-search__results-list" v-else-if="results.length">
                <div class="table-wrapper orders-history">
                    <table class="data table table-order-items history">
                        <thead>
                            <tr>
                                <th>Order #</th>
                                <th>Date</th>
                                <th>Invoice</th>
                                <th>Order Total</th>
                                <th>Status</th>
                                <th></th>
                                <!-- <th>View PDF</th> -->
                                <!-- <th>Action</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            
                            <tr v-for="result in results" :key="result.id">
                                <td data-th="Order #">{{ result.id }}</td>
                                <td data-th="Date">{{ formatDateForFrontend(result.date) }}</td>
                                <td data-th="Invoice">
                                    <InvoiceModal :poCode="`IO${result.id.substring(5)}`" :accountNumber="accountNumber" />
                                </td>
                                <td v-html="result.total" data-th="Order Total"></td>
                                <td data-th="Status">{{ result.status }}</td>
                                <td data-th="Actions" class="col actions">
                                    <a :href="result.url">View and reorder</a>
                                    <!-- <a :ref="el => setViewRef(result.id, el)" href="#" class="action view"><span>View</span></a>
                                    <a href="#" class="action view"><span>Reorder</span></a>
                                    <OrderModal :orderNumber="result.id" :clickTrigger="viewRefs[result.id]" /> -->
                                </td>
                            </tr>
                        </tbody>
                    </table> 
                </div>
              
            </div>

               
            <p v-else>No results found</p>
        </div>
    </div>
</template>

<script>
    import Loader from './Loader.vue';
    import OrderModal from './OrderModal.vue';
    import InvoiceModal from './InvoiceModal.vue';
    import VueDatePicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css'

    export default {
        name: 'OrderSearch',
        components: {
            VueDatePicker,
            Loader,
            InvoiceModal,
            OrderModal
        },
        props: {
            accountNumber: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                error: null,
                searching: false,
                loadingResults: false,
                searchTerm: '',
                searchType: '',
                searchOptions: [
                    { value: 'order_number', label: 'Order Number' },
                    { value: 'date', label: 'Date' },
                ],
                results: [],
                date: null,
                viewRefs: {}
            }
        },
        methods: {
            setViewRef(orderId, el) {
                if (el) {
                    this.viewRefs[orderId] = el;
                }
            },
            formatDateForFrontend(dateString) {
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                const year = date.getFullYear();
                
                return `${day}/${month}/${year}`;
            },
            formatDateForBackend(dateString) {
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                const year = date.getFullYear();
                
                return `${year}-${month}-${day}`;
            },
            async searchOrders() {
                this.searching = true;
                this.loadingResults = true;

                try {
                    let response = null;

                    if(this.searchType !== 'date'){
                        response = await fetch(
                            `/rest/V1/swallowdental/online-orders?type=${this.searchType}&search=${this.searchTerm}`,
                        );
                    }
                    else {
                        response = await fetch(
                            `/rest/V1/swallowdental/online-orders?type=date&fromDate=${this.formatDateForBackend(this.date[0])}&toDate=${this.formatDateForBackend(this.date[1])}`,
                        );
                    }

                    if (!response || !response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }

                    const data = await response.json();
                    this.error = null;
                    this.loadingResults = false;
                    this.results = data;

                } catch (error) {
                    this.loadingResults = false;
                    this.results = [];
                    // this.error = error.message;
                    console.error("Error fetching orders:", error);
                }
            }
        }
    };
</script>